// v-tooltip="{ text: 'text' }"
// v-tooltip="{ html: '<span>text</span' }"

// store events in global object to be able to remove them after update
window.storeTooltipListeners = [];

Vue.directive('tooltip', {
  
  update: function(el, binding) {
    // remove older events
    for (var i = 0; i < window.storeTooltipListeners.length; i++) {
      el.removeEventListener(window.storeTooltipListeners[i].event, window.storeTooltipListeners[i].func );
    }
    this.addEvents(el, binding);
  },

  bind: function(el, binding) {
    this.addEvents = function(el, binding) {
      var $tooltip = gE('tooltip'),
          param = binding.value;

      this.handleMouseOverTrigger = function(event) { 
        var $trigger = event.target;

        if (param.text) {
          $tooltip.textContent = param.text;
        } else if (param.html) {
          $tooltip.innerHTML = param.html;
        }
        var pos = $trigger.getBoundingClientRect();
        var left = document.documentElement.scrollLeft + document.body.scrollLeft + pos.left;
        var pageWidth = Math.max(html.clientWidth, win.innerWidth || 0);
        if (left + $tooltip.offsetWidth <= pageWidth) {
          $tooltip.style.left = (document.documentElement.scrollLeft + document.body.scrollLeft + pos.left) + 'px';
          $tooltip.style.right = '';
        } else {
          $tooltip.style.right = 0;
          $tooltip.style.left = '';
        }
        $tooltip.style.top = (document.documentElement.scrollTop + document.body.scrollTop + pos.top + $trigger.offsetHeight ) + 'px';
        $tooltip.style.minWidth = el.offsetWidth + 'px';
        $tooltip.classList.add('show');
      };
      this.handleMouseLeave = function(event) { 
        $tooltip.classList.remove('show');
      };
     
      this.handleClick = function() {
        var message;
        if (param.text) {
          message = param.text;
        } else if (param.html) {
          var dummy = document.createElement("p"); // convert html to text
          dummy.innerHTML = param.html;
          message = dummy.textContent;
        }
        window.alert(message);
      };

      if (!win.isMobile) {
        el.addEventListener('mouseover', this.handleMouseOverTrigger);
        window.storeTooltipListeners.push({ event: 'mouseover', func: this.handleMouseOverTrigger});
        el.addEventListener('mouseleave', this.handleMouseLeave);
        window.storeTooltipListeners.push({ event: 'mouseleave', func: this.handleMouseLeave});
        if (el.hasAttribute('title')) {
          el.removeAttribute('title');
        }
      } else {
        el.addEventListener('click', this.handleClick);
        window.storeTooltipListeners.push({ event: 'click', func: this.handleClick});
      }
    };

    this.addEvents(el, binding);

  },
  unbind: function(el) {
    el.removeEventListener('mouseover', this.handleMouseOverTrigger);
    el.removeEventListener('mouseleave', this.handleMouseLeave);
    el.removeEventListener('click', this.handleClick);
  }
});

